import React from 'react'

import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon, ChevronRightIcon } from '@radix-ui/react-icons'

const years = [
  {
    title: 'Phase 1: Foundation (15 months)',
    description:
      'Learn Frontend, Backend and Data-Structures, Build 5+ Projects and work on a Major Capstone project',
    chapters: [
      {
        heading: 'TriSem 1',
        chapters: [
          'Introduction to Programming',
          'Introduction to Data Structures & Algorithms',
          'Soft Skills 1'
        ]
      },
      {
        heading: 'TriSem 2',
        chapters: [
          'Introduction to Frontend Development',
          'Data Structures Advanced',
          'Database Management Systems'
        ]
      },
      {
        heading: 'TriSem 3',
        chapters: [
          'Introduction To Backend Development',
          'Advanced Frontend Development',
          'Soft Skills 2'
        ]
      },
      {
        heading: 'TriSem 4',
        chapters: [
          'DevOps Basics',
          'Advanced Backend Development',
          'Product Management'
        ]
      },
      {
        heading: 'TriSem 5 - Capstone',
        chapters: [
          'Identify a problem statement and get the solution validated',
          'Build a Responsive Frontend Using React/Next',
          'Design the Database schema, apply Indexes',
          'Build a highly Scalable app to support millions of requests',
          'Add Payment gateways, Mail Integration, Async Workflows',
          'Deploy it on a Cloud (AWS)',
          'Demo Day'
        ]
      }
    ]
  },
  {
    title: 'Phase 2 - Experience (12 months)',
    description:
      'A 12-month Paid Internship at top tech companies to make sure you gain industrial experience and make an impressive portfolio.'
  },
  {
    title: 'Phase 3 - Specialization (9 months)',
    description:
      'Choose Your own Specialisation from Artificial Intelligence and System Design or Build your own Startup.',
    chapters: [
      {
        heading: 'TriSem 10',
        chapters: [
          'Computer Networking & Operation Systems',
          'Compiler Design and Automata Theory',
          'Business Management'
        ]
      },
      {
        heading: 'TriSem 11 & 12 - Choose Your Specialization(One of these)',
        chapters: ['Build your startup', 'AI / ML', 'System Design']
      }
    ]
  }
]

const Curriculum = () => {
  return (
    <div className="bg-gradient-to-r from-indigo-900 to-primary-dark text-white">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:max-w-screen-2xl lg:px-8 w-full">
        <h2 className="text-4xl font-medium">Curriculum</h2>
        <hr className="w-full h-0 border border-px border-[#5553A7] my-6" />
        <div className="mt-8 lg:mt-10">
          {years.map((year) => (
            <Disclosure key={year.title}>
              {({ open }) => (
                <div className="my-12">
                  <Disclosure.Button className="text-left space-y-4">
                    <p className="text-2xl font-medium capitalize">
                      {year.title}
                    </p>
                    <p className="flex items-center gap-1 text-lg text-purple-200">
                      {year.chapters &&
                        (open ? (
                          <ChevronDownIcon className="w-4 h-4" />
                        ) : (
                          <ChevronRightIcon className="w-4 h-4" />
                        ))}
                      {year.description}
                    </p>
                  </Disclosure.Button>
                  <Disclosure.Panel>
                    <ul className="">
                      {year.chapters &&
                        year.chapters.map((chapter, index) => {
                          if (!chapter) return null

                          const isSingleChapters = typeof chapter === 'string'
                          if (isSingleChapters) {
                            return (
                              <li key={index} className="py-4">
                                {chapter}
                              </li>
                            )
                          } else {
                            return (
                              <Disclosure key={index}>
                                {({ open }) => (
                                  <div className="my-4">
                                    <Disclosure.Button className="text-left space-y-4">
                                      <p className="flex items-center gap-x-4 font-semibold">
                                        {open ? (
                                          <ChevronDownIcon className="w-4 h-4" />
                                        ) : (
                                          <ChevronRightIcon className="w-4 h-4" />
                                        )}{' '}
                                        {chapter.heading}{' '}
                                      </p>
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="pl-4 mt-2">
                                      <ul className="list-disc px-4">
                                        {chapter.chapters.map((chapter) => {
                                          return (
                                            <li key={chapter} className="py-2">
                                              {chapter}
                                            </li>
                                          )
                                        })}
                                      </ul>
                                    </Disclosure.Panel>
                                  </div>
                                )}
                              </Disclosure>
                            )
                          }
                        })}
                    </ul>
                  </Disclosure.Panel>
                </div>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Curriculum
